module.exports = __webpack_public_path__ + "img/sulfite.aa784f7e.svg";